/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRemoveSelected = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M13 3H3v4h10zm0 14H3v4h10z" />
        <path
          clipRule="evenodd"
          d="M2 9h12v6H2zm2 2v2h8v-2zm16.414 1 1.293 1.293-1.414 1.414L19 13.414l-1.293 1.293-1.414-1.414L17.586 12l-1.293-1.293 1.414-1.414L19 10.586l1.293-1.293 1.414 1.414z"
          fillRule="evenodd"
        />
      </g>
    </g>
  </Icon>
);
export { SvgRemoveSelected as RemoveSelected };
